import { Injectable, inject, signal, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

interface ServerMonitoringResponse {
    cpuPercentage: number;
    memoryPercentage: number;
}

@Injectable({
    providedIn: 'root'
})
export class SystemMonitorService implements OnDestroy {
    readonly #http = inject(HttpClient);
    private readonly apiUrl = environment.apiUrl;

    cpuUsage = signal<number>(0);
    memoryUsage = signal<number>(0);

    #intervalId: ReturnType<typeof setInterval> | null = null;

    constructor() {
        this.fetchMetrics();
        this.#intervalId = setInterval(() => this.fetchMetrics(), 60_000);
    }

    ngOnDestroy() {
        if (this.#intervalId) {
            clearInterval(this.#intervalId);
        }
    }

    private fetchMetrics() {
        this.#http.get<ServerMonitoringResponse>(
            `${this.apiUrl}/ServerMonitoring`
        ).subscribe({
            next: (data) => {
                this.cpuUsage.set(Math.round(data.cpuPercentage));
                this.memoryUsage.set(Math.round(data.memoryPercentage));
            },
            error: (err) => {
                console.error('Erro ao buscar métricas do servidor:', err);
            }
        });
    }
}
